/**
 * Created by Ashok on 30-03-2016.
 */
import { AlertController, NavController } from '@ionic/angular/index';
import { Renderer2 } from '@angular/core';
import * as appProp from './appProperties';
//  import { MyGolfStorageService } from './storage/mygolf-storage.service';

// import {Router} from '@angular/router';
/**
 * Generates the UUID String
 * @returns {string}
 */
export function generateUUID() {
  var d = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = ((d + Math.random() * 16) % 16) | 0;
    d = Math.floor(d / 16);
    return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
}

export async function displayError(alertCtl: AlertController, error: any, title: string, buttonText: string) {
  let msg = null;
  if (error && error.message) msg = error.message;
  else if (error && error.exception) msg = error.exception;
  else if (error) msg = JSON.stringify(error);

  let alert = await alertCtl.create({
    header: 'title',
    message: msg,
    buttons: [buttonText],
  });
  alert.present();
}
export function randomIntFromInterval(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1) + min);
}
export function getErrorMessage(error: any): string {
  let msg = null;
  if (error && error?.error) msg = error?.error?.errorMessage;
  else if (error && error.message) msg = error.message;
  else if (error && error.exception) msg = error.exception;
  else if (error) msg = JSON.stringify(error);
  return msg;
}
/**
 * Gets the distance between two co-ordinates of GPS
 * @param lat1 The latitude of first point
 * @param lon1 The longitude of first point
 * @param lat2 The latitude of second point
 * @param lon2 The longitude of second point
 * @returns {number} Return the distance in KM
 */
export function getDistanceInKM(lat1: number, lon1: number, lat2: number, lon2: number): string {
  var R = 6371; // Radius of the earth in km
  var dLat = deg2rad(lat2 - lat1); // deg2rad below
  var dLon = deg2rad(lon2 - lon1);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c; // Distance in km
  return d.toFixed(0);
}
export function getDistanceInMeters(lat1: number, lon1: number, lat2: number, lon2: number): number {
  var R = 6371; // Radius of the earth in km
  var dLat = deg2rad(lat2 - lat1); // deg2rad below
  var dLon = deg2rad(lon2 - lon1);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c; // Distance in km
  return d * 1000;
}
function deg2rad(deg) {
  return deg * (Math.PI / 180);
}
export function adjustViewZIndex(
  nav: NavController,
  //   renderer: Renderer2 | Renderer
  renderer: Renderer2 | Renderer2
) {
  // let totalViews = nav.length();
  // let zindex = 100;
  // for(let i=0; i < totalViews; i++){
  //     let view = nav.getByIndex(i);
  //     view._setZIndex(zindex, renderer);
  //     zindex++;
  // }
}

// export function getURL(router: Router) {
//     console.log("get current url " ,router.url)
// }
/**
 * This is the shared object visible acorss all the pages
 */
export var SharedObject: any = {};
// export const MygolfServerHost = '192.168.1.133';

// export const MygolfServerPort = 1400;
// console.log("get current url ". window.location.href)
// getURL();
// export const MygolfServerHost = 'devlet.mygolf2u.com';
// export const MygolfServerPort = 80;
// export const MygolfServerProtocol = 'http';
// export var MygolfServer = `${MygolfServerProtocol}://${MygolfServerHost}:${MygolfServerPort}`;
export const appType: string = appProp.appType; //'main'
export const clubId: number = appProp.clubId; //null;
export const MygolfServerHost = appProp.MygolfServerHost;
//export const MygolfServerHost = 'miglet.mygolf2u.com';
//export const MygolfServerPort = 443;
//export const MygolfServerProtocol = 'https';
const MygolfSSLEnable = appProp.MygolfSSLEnable;
export const MygolfServerPort = MygolfSSLEnable ? 443 : 80;
export const MygolfServerProtocol = MygolfSSLEnable ? 'https' : 'http';
export const environment = appProp.environment;
export var MygolfServer = `${MygolfServerProtocol}://${MygolfServerHost}:${MygolfServerPort}`;

export const OneSignalAppID = appProp.OneSignalAppID;

export const devMode = appProp.devMode;
export const testClubID = appProp.testClubID;
export const testPartnerId = appProp.testPartnerID;
export const testClubName = appProp.testClubName;

export const enableChat = appProp.enableChat;
export const appClient = '';
export const organizerId = null;

// export var MygolfServer = `http://${MygolfServerHost}:${MygolfServerPort}`;
// export var MygolfServer = `http://${MygolfServerHost}`;

// "http://192.168.1.133:1400";
// export var MygolfServer = "http://localhost:1400";
// B2 Development Server
// export var MygolfServer = "http://test.britesoft.com";

// B2 Development Server
// export var MygolfServer = "http://testlet.mygolf2u.com";
// export var MygolfServer = "http://192.168.0.109:7071";
// export var MygolfServer = "http://azulet.mygolf2u.com";
// export var MygolfServer = "http://192.168.0.232:1400";
// Production Server
// export var MygolfServer = "http://azulet.mygolf2u.com";

export var AUTH_TOKEN_NAME = 'X-AUTH-TOKEN';

export const GOOGLE_MAP_ANDROID_KEY = 'AIzaSyDpbMcldv1v_kgCI_yYQmO737_PbvueKqc';
export const GOOGLE_MAP_IOS_KEY = 'AIzaSyDpbMcldv1v_kgCI_yYQmO737_PbvueKqc';
var competitionBase = MygolfServer + '/rest/competition';
var friendsBase = MygolfServer + '/rest/friends';
var pushNotificationBase = MygolfServer + '/rest/pushnotification';
export const teeTimeBookingBase = MygolfServer + '/rest/tee-time/booking';
export const teeTimeSlotBase = MygolfServer + '/rest/tee-time/slot';
export const userProfile = MygolfServer + '/rest/user-profile';
export const packages = MygolfServer + '/rest/stay-and-play/packages';
export const stayAndPlay = MygolfServer + '/rest/stay-and-play';
export var ServerUrls: any = {
  authentication: MygolfServer + '/api/login',

  savePartnerPackageInfo: MygolfServer + '/rest/stay-and-play/packages/partners', // add partnerId if partner admin
  saveClubPackageInfo: MygolfServer + '/rest/stay-and-play/packages/clubs', // add partnerId if club admin
  editPackageInfo: MygolfServer + '/rest/stay-and-play/packages', // add {packageId}
  getAllPackages: MygolfServer + '/rest/stay-and-play/packages',
  searchPackage: MygolfServer + '/rest/stay-and-play/packages',
  getPackageById: MygolfServer + '/rest/stay-and-play/packages', // Add {packageId}
  deletePackage: MygolfServer + '/rest/stay-and-play/packages', // Add {packageId}
  rearrangeImages: MygolfServer + '/rest/stay-and-play/packages',

  savePackageImage: MygolfServer + '/rest/stay-and-play/packages', // add {packageId}/images
  deletePackageImage: MygolfServer + '/rest/stay-and-play/packages', // add {packageId}/images
  savePlayOption: MygolfServer + '/rest/stay-and-play/packages', // add {packageId}/play-options
  editPlayOption: MygolfServer + '/rest/stay-and-play/packages', // add {packageId}/play-options/{playOptionId}
  saveStayOption: MygolfServer + '/rest/stay-and-play/packages', // add {packageId}/stay-options
  editStayOption: MygolfServer + '/rest/stay-and-play/packages', // add {packageId}/stay-options/{stayOptionId}
  deleteStayOption: MygolfServer + 'rest/stay-and-play/packages', //delete stay option
  getAllHotels: MygolfServer + '/rest/stay-and-play/hotels', // add {packageId}/stay-options

  saveNearByInfo: MygolfServer + '/rest/stay-and-play/packages',
  deleteNearByInfo: MygolfServer + '/rest/stay-and-play/packages',

  getPackageRequest: MygolfServer + '/rest/stay-and-play/requests',

  registerPlayer: MygolfServer + '/rest/register/player',
  registerFriend: MygolfServer + '/rest/register/friend',
  updatePhoto: MygolfServer + '/rest/update/photo',
  updatePlayerProfile: MygolfServer + '/rest/update/player/profile',
  updatePlayerNHS: MygolfServer + '/rest/update/player/nhs',
  playerMain: MygolfServer + '/rest/main/player',
  forgotPassword: MygolfServer + '/rest/forgotpassword',
  startRestPassword: MygolfServer + '/rest/startpasswordreset',
  resetPassword: MygolfServer + '/rest/resetpassword',
  changePassword: MygolfServer + '/rest/changepassword',
  playerMemberships: MygolfServer + '/rest/player/clubmemberships',
  updatePlayerMembership: MygolfServer + '/rest/player/clubmembership/update',
  deletePlayerMembership: MygolfServer + '/rest/player/clubmembership/delete',
  // http://azulet.mygolf2u.com/rest/handicap/recalculate-handicap-index?playerId=199
  calculateHandicapIndex: MygolfServer + '/rest/handicap/recalculate-handicap-index',
  getCourseHandicap: MygolfServer + '/rest/handicap/player-course-handicap',
  competitionDetails: competitionBase + '/details',
  competitionInfo: competitionBase + '/info',
  upcomingCompetitionList: competitionBase + '/list/upcoming',
  listAllCompetitions: competitionBase + '/list/all',
  searchCompetitions: competitionBase + '/search',
  competitionPlayers: competitionBase + '/players/list',
  competitionScorers: competitionBase + '/scoringplayers',

  getPlayerHcpList: MygolfServer + '/rest/handicap/player-handicap-calculations',
  getPlayerClubHcp: MygolfServer + '/rest/handicap/get-club-handicaps',
  getHcpIdxSubscription: MygolfServer + '/rest/feature/handicap-index-subscription/player',
  getTrialSubscription: MygolfServer + '/rest/feature/request-handicap-index-trial/player',
  generateHcpCalculation: MygolfServer + '/rest/handicap/recalculate-handicap-index',
  getHcpIdxBundles: MygolfServer + '/rest/feature/handicap-index-bundles', //?country=

  competitionRegister: competitionBase + '/players/register',
  competitionDeregister: competitionBase + '/players/deregister',
  // competitionDeregister     : competitionBase + "/player/dergister",
  // competitionDeregister     : "/rest/competitions" + "/de-register",
  competitionSponsors: competitionBase + '/sponsors/list',
  competitionPrizes: competitionBase + '/prizes/list',
  competitionFlights: competitionBase + '/flights/list',
  competitionLeaderboard: competitionBase + '/leaderboard',
  competitionRoundForScoring: competitionBase + '/roundforscoring',
  activeCompetitions: competitionBase + '/active/list',
  activeCompetitionsForClub: competitionBase + '/active/list/club',
  activeCompetitionsForOrganizer: competitionBase + '/active/list/organizer',
  competitionFlightChanged: competitionBase + '/flightchanged',

  competitionScorecardGetOrCreate: competitionBase + '/scorecard/create',
  competitionScorecardUpdate: competitionBase + '/scorecard/update',
  competitionScorecardSync: competitionBase + '/scorecard/sync',
  competitionScorecardGet: competitionBase + '/scorecard/get',

  competitionChangeScorer: competitionBase + '/changescorer',
  competitionWithdraw: competitionBase + '/withdraw',
  competition: {
    getAllPlayerScores: competitionBase + '/playerallscores',
  },
  friendsList: friendsBase + '/list',
  friendsTotal: friendsBase + '/total',
  friendsPending: friendsBase + '/pending/list',
  friendsPendingTotal: friendsBase + '/pending/total',
  friendRequestSend: friendsBase + '/request',
  friendRequestAccept: friendsBase + '/accept',
  friendRequestCancel: friendsBase + '/cancel',

  getNewsList: MygolfServer + '/rest/news',
  getClubList: MygolfServer + '/rest/clubs',
  getClubListLite: MygolfServer + '/rest/clubs/lite',
  getPartnerList: MygolfServer + '/rest/partners',
  saveNewsForClub: MygolfServer + '/rest/news/clubs/:clubId',
  saveNewsForPartner: MygolfServer + '/rest/news/partners/:partnerId',
  saveNewsForMyGolf2U: MygolfServer + '/rest/news/mygolf2u',
  deleteNews: MygolfServer + '/rest/news/:newsId',
  updateNews: MygolfServer + '/rest/news/:newsId',

  news: {
    moveToClub: MygolfServer + '/rest/news/:newsId/move-to-club/:clubId',
    moveToPartner: MygolfServer + '/rest/news/:newsId/move-to-partner/:partnerId',
    moveToMygolf2u: MygolfServer + '/rest/news/:newsId/move-to-mygolf',
  },
  promoAds: {
    moveToClub: MygolfServer + '/rest/offers-and-ads/:id/move-to-club/:clubId',
    moveToPartner: MygolfServer + '/rest/offers-and-ads/:id/move-to-partner/:partnerId',
    moveToMygolf2u: MygolfServer + '/rest/offers-and-ads/:id/move-to-mygolf',
  },

  getPromotionList: MygolfServer + '/rest/offers-and-ads',
  savePromotionForClub: MygolfServer + '/rest/offers-and-ads/clubs/:clubId',
  savePromotionForPartner: MygolfServer + '/rest/offers-and-ads/partners/:partnerId',
  savePromotionForMyGolf2U: MygolfServer + '/rest/offers-and-ads/mygolf2u',
  deletePromotion: MygolfServer + '/rest/offers-and-ads/:promotionId',
  updatePromotion: MygolfServer + '/rest/offers-and-ads/:promotionId',

  getHomeItems: MygolfServer + '/rest/home-items',
  getHomeItemForClub: MygolfServer + '/rest/home-items/clubs/:clubId/icons',
  getHomeItemForPartner: MygolfServer + '/rest/home-items/partners/:partnerId/icons ',
  saveHomeItemForClub: MygolfServer + '/rest/home-items/clubs/:clubId/icons',
  saveHomeItemForPartner: MygolfServer + '/rest/home-items/partners/:partnerId/icons',
  deleteHomeItemForClub: MygolfServer + '/rest/home-items/clubs/:clubId/icons',
  deleteHomeItemForPartner: MygolfServer + '/rest/home-items/partners/:partnerId/icons',

  scorecardGet: MygolfServer + '/rest/scorecard/get',
  scorecardSearch: MygolfServer + '/rest/scorecard/search',

  getClub: MygolfServer + '/rest/club/get',
  getClubData: MygolfServer + '/rest/club/:clubId',
  getClubCourses: MygolfServer + '/rest/club/courses',
  getClubCourseGroup: MygolfServer + '/rest/club/:clubId/course-groups',
  getClubsNearby: MygolfServer + '/rest/clubs/nearby',
  getRecentClubs: MygolfServer + '/rest/clubs/recent',
  searchClubsOpen: MygolfServer + '/rest/clubs/search/open',
  searchClubs: MygolfServer + '/rest/clubs/search',
  // searchClubs: MygolfServer + "/rest/club/search", //! new

  searchPlayers: MygolfServer + '/rest/players/search',
  newSearchPlayers: MygolfServer + '/rest/players',
  nonFriendPlayers: MygolfServer + '/rest/players/nonfriends',
  getPlayerGroups: MygolfServer + '/rest/players/groups/get',
  deletePlayerGroup: MygolfServer + '/rest/players/groups/delete',
  createPlayerGroup: MygolfServer + '/rest/players/groups/create',
  saveNormalGame: MygolfServer + '/rest/normalgame/scorecard/save',
  deleteNormalGameScorecar: MygolfServer + '/rest/normalgame/scorecard/delete',
  changeCourse: MygolfServer + '/rest/normalgame/changecourse',
  importScorecard: MygolfServer + '/rest/normalgame/scorecard/import',
  getPlayerPerformanceBase: MygolfServer + '/rest/player/performance',
  getPlayerPerformanceDetails: MygolfServer + '/rest/player/performancedetail',
  getPlayerPerformanceChart: MygolfServer + '/rest/player/performancechart',
  getPlayerInfo: MygolfServer + '/rest/player/get',
  getPlayerDetails: MygolfServer + '/rest/players/:playerId',
  getPlayerAnalysisHole: MygolfServer + '/rest/player/holeanalysis',

  listFeedbackCategories: MygolfServer + '/rest/feedback/categories',
  createPlayerFeedback: MygolfServer + '/rest/feedback/player/create',

  getCountries: MygolfServer + '/rest/countries',
  getClubCountries: MygolfServer + '/rest/club-countries',
  getStates: MygolfServer + '/rest/states',
  getCities: MygolfServer + '/rest/cities',

  addPlayerFavoriteClub: MygolfServer + '/rest/player/favoriteclub/add',
  deletePlayerFavoriteClub: MygolfServer + '/rest/player/favoriteclub/delete',
  addPlayerFavoriteLocation: MygolfServer + '/rest/player/favoritelocation/add',
  deletePlayerFavoriteLocation: MygolfServer + '/rest/player/favoritelocation/delete',
  getPlayerFavoriteLocations: MygolfServer + '/rest/player/favoritelocation/list',
  getPlayerFavoriteClubs: MygolfServer + '/rest/player/favoriteclub/list',
  getPlayerHandicapIndex: MygolfServer + '/rest/player/handicapindex/get',
  updatePlayerClubHandicap: MygolfServer + '/rest/player/clubhandicap/update',
  serverInfo: MygolfServer + '/rest/server/info',
  pushNotificationServerInfo: pushNotificationBase + '/serverinfo',
  getPrivateCompetitionList: competitionBase + '/private/list',
  getCompetitionTeamList: competitionBase + '/teams/list',

  getAdsForDisplay: MygolfServer + '/rest/advertisement/fordisplay',
  getTeebox: MygolfServer + '/rest/tee-boxes',

  //BILLPLZ
  billplz_testCall: MygolfServer + '/rest/payment/billplz/test-call',
  billplz_createCollection: MygolfServer + '/rest/payment/billplz/create-collection',
  billplz_updateCollection: MygolfServer + '/rest/payment/billplz/update-collection',
  billplz_createBill: MygolfServer + '/rest/payment/billplz/create-bill',
  billplz_getRemoteCollection: MygolfServer + '/rest/payment/billplz/get-remote-collection',
  billplz_getRemoteBill: MygolfServer + '/rest/payment/billplz/get-remote-bill',
  billplz_getLocalBill: MygolfServer + '/rest/payment/billplz/get-local-bill',
  billplz_paymentRedirect: MygolfServer + '/rest/payment/billplz/redirect',
  billplz_paymentCallback: MygolfServer + '/rest/payment/billplz/callback',
  billplz_updateBill: MygolfServer + '/rest/payment/billplz/update-bill',
  billplz_getBillCompetition: MygolfServer + '/rest/payment/billplz/get-bill-competition',
  billplz_getCompCollection: MygolfServer + '/rest/payment/billplz/get-collection-competition', //competition int
  billplz_getClubCollection: MygolfServer + '/rest/payment/billplz/get-collection-club', //club int
  billplz_getPremiumFeatureCollection: MygolfServer + '/rest/payment/billplz/get-collection-premium-feature-pricing', //premium-feature-pricing (id)

  //iPay88
  ipay88_testCall: MygolfServer + '/rest/payment/ipay88/test-call',
  ipay88_createCollection: MygolfServer + '/rest/payment/ipay88/create-collection',
  ipay88_updateCollection: MygolfServer + '/rest/payment/ipay88/update-collection',
  ipay88_createBill: MygolfServer + '/rest/payment/ipay88/create-bill',
  ipay88_getRemoteCollection: MygolfServer + '/rest/payment/ipay88/get-remote-collection',
  ipay88_getRemoteBill: MygolfServer + '/rest/payment/ipay88/get-remote-bill',
  ipay88_getLocalBill: MygolfServer + '/rest/payment/ipay88/get-local-bill',
  ipay88_paymentRedirect: MygolfServer + '/rest/payment/ipay88/redirect',
  ipay88_paymentCallback: MygolfServer + '/rest/payment/ipay88/callback',
  ipay88_updateBill: MygolfServer + '/rest/payment/ipay88/update-bill',
  ipay88_getBillCompetition: MygolfServer + '/rest/payment/ipay88/get-bill-competition',
  ipay88_getCompCollection: MygolfServer + '/rest/payment/ipay88/get-collection-competition', //competition int
  ipay88_getClubCollection: MygolfServer + '/rest/payment/ipay88/get-collection-club', //club int
  ipay88_getPremiumFeatureCollection: MygolfServer + '/rest/payment/ipay88/get-collection-premium-feature-pricing', //premium-feature-pricing (id)
  ipay88_merchantKey: MygolfServer + '/rest/payment/ipay88/get-merchant-key',

  // getPaymentGateway: MygolfServer + "/rest/payment/get-payment-gateway",
  getPaymentGateway: MygolfServer + '/rest/payment/payment-gateways',

  getAvailableCaddies: MygolfServer + '/rest/club/caddy/list-available-caddies', //?clubId=&availableOn=
  getAvailableBuggies: MygolfServer + '/rest/club/buggy/list-available-buggies', //?clubId=&availableOn=
  getCaddyList: MygolfServer + '/rest/club/caddy/list-caddies', //?clubId=28101520
  getBuggyList: MygolfServer + '/rest/club/buggy/list-buggies', //?clubId=28101520
  getCaddySchedule: MygolfServer + '/rest/club/caddy/schedule',
  getBuggySchedule: MygolfServer + '/rest/club/buggy/schedule',
  getCaddyDayDetails: MygolfServer + '/rest/club/caddy/caddie-details',
  getBuggyDayDetails: MygolfServer + '/rest/club/buggy/buggy-details',

  getCaddyInfo: MygolfServer + '/rest/club/caddy/info', //{caddieId}

  getCaddyRatings: MygolfServer + '/rest/club/caddy/ratings',
  getCaddyAssignments: MygolfServer + '/rest/club/caddy/assignments', // /{caddieId}

  getTeeTimeBookingList: MygolfServer + '/rest/tee-time/booking/list', //?clubId=28101520&forDate=2020-05-27&registeredOnly=true",
  getClubBookingList: MygolfServer + '/rest/tee-time/booking', //{clubId*} ?fromDate&toDate&pageSize(def=20)&pageNo(def=1)",
  getTeeTimeSlot: MygolfServer + '/rest/tee-time/slot/list', //?clubId=28101520&forDate=2020-05-28"
  getTeeTimeSlotNearbyClubs: MygolfServer + '/rest/tee-time/slot/list-in-nearby-clubs',
  getTeeTimeSlotFavClubs: MygolfServer + '/rest/tee-time/slot/list-in-favorite-clubs',

  bookTeeTimeBookingSlot: MygolfServer + '/rest/tee-time/booking/book-a-slot',
  getClubBookingOptions: MygolfServer + '/rest/tee-time/booking/options', //?clubId=&forDate=

  getBookingByPlayer: MygolfServer + '/rest/tee-time/booking/created-by-player',
  getBookingForPlayer: MygolfServer + '/rest/tee-time/booking/for-player',
  addPlayerToBooking: MygolfServer + '/rest/tee-time/booking/add-a-player',
  deletePlayerFromBooking: MygolfServer + '/rest/tee-time/booking/delete-a-player',
  getPlayerById: MygolfServer + '/rest/players/get-by-id', //?playerId
  getPlayerByMembership: MygolfServer + '/rest/players/get-by-membership', //?membership=&clubId=
  searchPlayerByMembership: MygolfServer + '/rest/players/search-by-membership', //?membership=&clubId=
  updateBookingPlayerContact: MygolfServer + '/rest/tee-time/booking/update-player-contact', //?bookingPlayerId=
  updateBookingPlayerDetails: MygolfServer + '/rest/tee-time/booking/update-player', //?bookingId=
  getBookingById: MygolfServer + '/rest/tee-time/booking/get',
  addFromGroup: MygolfServer + '/rest/tee-time/booking/add-from-group',
  cancelBooking: MygolfServer + '/rest/tee-time/booking/cancel', //bookingId=&cancelledByClub=<true|false>&reason=<optional string>,
  checkinBooking: MygolfServer + '/rest/tee-time/booking/checkin', //bookingId=<number*>&arrivingIn=<integer*>&byClub=<boolean|optional|default false>&bookingPlayerId=<integer[]*>
  processBookingAssignments: MygolfServer + '/rest/tee-time/booking/process-assignments', //bookingId
  getPlayerByEmail: MygolfServer + '/rest/player/getbyemail',
  updateBookingFlightStatus: MygolfServer + '/rest/tee-time/booking/update-flight-status',
  updateBuggyCaddyPreference: MygolfServer + '/rest/tee-time/booking/update-buggy-caddie-preference',
  getBookingItemizedBill: MygolfServer + '/rest/tee-time/booking/itemized-bill', //bookingId
  //bookingId=<integer>&status=<Dispatched | PlayStarted | CrossedOver | PlayFinished | Abandoned>
  cancelBookingAssignments: MygolfServer + '/rest/tee-time/booking/cancel-assignments',
  changeBuggyFlight: MygolfServer + '/rest/tee-time/course-starter/change-buggy', //bookingId=<number>, bookingPlayerId=<[number]>, buggyId=number,
  changeCaddyFlight: MygolfServer + '/rest/tee-time/course-starter/change-caddy', //bookingId=<number>, bookingPlayerId=<[number]>, buggyId=number,
  clubBookingSlot: MygolfServer + '/rest/tee-time/club/booking/book-a-slot', //can use for change course or time slot too
  changeSlot: MygolfServer + '/rest/tee-time/course-starter/change-slot', //bookingId=&slotDayId=&slotNo=
  rateForClub: MygolfServer + '/rest/rating/clubs', // /{clubId}
  rateForCaddie: MygolfServer + '/rest/rating/caddies', // /{caddieId} &playerId, rating
  getClubRatingItems: MygolfServer + '/rest/rating/club-rating-items',
  moveFlightSlot: MygolfServer + '/rest/tee-time/course-starter/move-slot', // bookingId&teeOffDate&slotNo
  swapFlightSlot: MygolfServer + '/rest/tee-time/course-starter/swap-slots', //firstBookingId=&secondBookingId=
  getBookingStats: MygolfServer + '/rest/tee-time/stats/club-flight-stat', //clubId
  getBookStatPlayerInfo: '/with-player-info', //to be use with getBookingStats
  getCourseUtilStats: MygolfServer + '/rest/tee-time/stats/course-utilization', //clubId
  getCaddyBuggyStats: MygolfServer + '/rest/tee-time/stats/caddie-buggy-utilization', //clubId
  getCaddyBuggyDayStats: MygolfServer + '/rest/tee-time/stats/caddie-buggy-statistics', //clubId
  getBuggyAvailabilityStats: MygolfServer + '/rest/club/:clubId/buggies/availability-stat',
  getFutureStats: MygolfServer + '/rest/tee-time/stats/future-revenue', //clubId
  clubCapturePayment: MygolfServer + '/rest/tee-time/club/booking/capture-payment',
  updateBookingMedium: MygolfServer + '/rest/tee-time/club/booking/update-booking-medium',
  //discounts and vouchers
  bookingApplyVoucher: MygolfServer + '/rest/tee-time/booking/apply-voucher', // bookingId&voucherId&force(def=false)
  listActiveDiscounts: MygolfServer + '/rest/discount/club-active-discounts', // clubId*&effectiveDate
  listClubDiscountProgram: MygolfServer + '/rest/discount/club-discount-program', // clubId&programId
  listActiveClubPlayerVouchers: MygolfServer + '/rest/discount/vouchers/active-player-club-vouchers', //clubId & playerId
  listClubDiscounts: MygolfServer + '/rest/discount/club-discounts', //clubId* & search & pageSize(def=30) & pageNo(def=1)
  getDiscount: MygolfServer + '/rest/discounts', // /discountId
  listDiscountCompanies: MygolfServer + '/rest/discount/companies', //search & pageSize(def=30) & pageNo(def=1)
  listClubVoucherSeries: MygolfServer + '/rest/discount/vouchers/series', //clubId*&search&pageSize(def=30)&pageNo(def=1)
  assignClubPlayerVoucher: MygolfServer + '/rest/discount/vouchers/assign', //clubId*&playerId*&voucherSeriesId*&numberOfVouchers*&validFrom
  listActivePlayerVouchers: MygolfServer + '/rest/discount/vouchers/active-player-vouchers', //clubId & playerId
  unassignClubPlayerVoucher: MygolfServer + '/rest/discount/vouchers/unassign', //clubId*&playerId*&[voucherIds]*
  transferPlayerVoucher: MygolfServer + '/rest/discount/vouchers/transfer-voucher', //clubId*&playerId*voucherId*&transfer*(playerId)
  listDiscountPrograms: MygolfServer + '/rest/discount/programs', // companyId*
  listPlayerVouchers: MygolfServer + '/rest/discount/vouchers/player-vouchers', //clubId & playerId
  redeemPlayerVoucher: MygolfServer + '/rest/discount/vouchers/redeem', //clubId
  voucherSeries: {
    listByClub: MygolfServer + '/rest/voucher-series/:clubId', //clubId*&search&pageSize(def=30)&pageNo(def=1)
  },

  //paramter with * is required
  // def is default
  //refund
  setRefundBookingPlayer: MygolfServer + '/rest/tee-time/booking/refund', // bookingId*&playerId*&amount*&refundMode(def=CASH|BTRF|CLBC|M2UC)&reason*
  applyPlayerBookingVoucher: MygolfServer + '/rest/tee-time/booking/apply-voucher', //bookingId*&voucherId*&force(def=false)
  removePlayerBookingVoucher: MygolfServer + '/rest/tee-time/booking/remove-voucher', //bookingId*&voucherId*
  applyPlayerBookingDiscount: MygolfServer + '/rest/tee-time/booking/apply-discount', //bookingId*&discountId*
  removePlayerBookingDiscount: MygolfServer + '/rest/tee-time/booking/remove-discount', //bookingId*&discountId*
  getPlayerClubApplicablePlayerTypes: MygolfServer + '/rest/tee-time/player-types', //clubId*&playerId*&effectiveDate
  getClubApplicablePlayerTypes: MygolfServer + '/rest/tee-time/booking/player-types', //clubId*
  createPlayerDiscountCard: MygolfServer + '/rest/discount/program/create-player-discount', //playerId*&programId*&membershipNo&validFrom&validUntil
  getPlayerCredits: MygolfServer + '/rest/player/list-credits', //playerId*
  getPlayerClubCredits: MygolfServer + '/player/club-credit', //playerId*&clubId*
  transferAndApplyVoucher: MygolfServer + '/rest/tee-time/booking/transfer-and-apply-voucher',

  // listPlayerDiscountCardApplications  :
  listClubVouchersIssued: MygolfServer + '/rest/discount/vouchers/list-vouchers-issued', //clubId*&seriesId&search&includeRedeemed(false)&includeExpired(false)&pageSize(30)&pageNo(1)
  listPlayerDiscountPrograms: MygolfServer + '/rest/discount/program/player-discount-programs', //playerId*
  deletePlayerDiscountCard: MygolfServer + '/rest/discount/program/delete-player-discount', //playerDiscountId*
  // approvePlayerDiscountCard   : MygolfServer + "/rest/discount/program/approve-player-discount", //playerId*&programId*&clubId*&validFrom&validUntil
  approvePlayerDiscountCard: MygolfServer + '/rest/discount/program/approve-player-discounts/:clubId',
  applyForClubVerifyDiscountCard: MygolfServer + '/rest/discount/program/apply-for-club-verification', //playerId*&programId*&clubId
  removeCardClubApplication: MygolfServer + '/rest/discount/program/delete-club-application', //{clubId}?playerDiscountId=<id>
  redeemClubCredit: MygolfServer + '/rest/tee-time/booking/redeem-club-credit', //bookingId*&playerId*&amount*
  listAllCardApplyForPlayer: MygolfServer + '/rest/discount/program/list-player-discount-card-applications', //playerId*&programId*&pendingOnly(false)&includeExpired(false)
  listAllPlayersCardDiscount: MygolfServer + '/rest/discount/program/list-club-discount-card-applications', //clubId*&programId*&pendingOnly(false)&includeExpired(false)
  getApplicableDiscountsForPlayer: MygolfServer + '/rest/discount/applicable', //clubId*&playerId*&effectiveDate
  approveMultiPlayerDiscountCard: MygolfServer + '/rest/discount/program/approve-player-discounts', //playerId*&programId*&clubId*&validFrom&validUntil
  listDiscountProgramsClub: MygolfServer + '/rest/discount/programs/clubs', // programId*&search&pageSize(30)&pageNo(1)
  undoApprovePlayerDiscountCard: MygolfServer + '/rest/discount/program/undo-approve-player-discount', //playerId*&programId*&clubId*&\
  updatePlayerDiscountDocument: MygolfServer + '/rest/discount/program/update-player-discount-document', //id*
  recalculateBookingPricing: MygolfServer + '/rest/tee-time/booking/trigger-pricing', //bookingId*

  listAllSlots: MygolfServer + '/rest/tee-time/slot/list-from-all-clubs', //playerId*&forDate*&fromTime&toTime
  searchAllSlots: MygolfServer + '/rest/tee-time/slot/search-slots', //playerId*&forDate*&fromTime&toTime
  bookingWaiveOff: MygolfServer + '/rest/tee-time/booking/waive-off', //bookingId*&amount*&reason
  undoBookingWaiveOff: MygolfServer + '/rest/tee-time/booking/undo-waive-off', //bookingId*&amount*&reason

  cancelBookingByClub: MygolfServer + '/rest/tee-time/booking/cancel-by-club', //CancelBookingSpecification

  assignBookingPlayerType: MygolfServer + '/rest/players/booking-player-types/assign', //playerId*&bookingPlayerType*& {file:string}
  assignableBookingPlayerType: MygolfServer + '/rest/players/booking-player-types/assignable', //
  assignedBookingPlayerType: MygolfServer + '/rest/players/booking-player-types/assigned', //playerId*
  removeBookingPlayerType: MygolfServer + '/rest/players/booking-player-types/remove', //playerId*&bookingPlayerType*&
  listBookingPlayerType: MygolfServer + '/rest/tee-time/booking/player-types', //clubId

  listClubMembership: MygolfServer + '/rest/club/members', //clubId*&activeOnly(def=true)&search
  getAvailableCaddieBooking: MygolfServer + '/rest/club/caddy/list-available-caddies/booking', //bookingId*
  getHandicapSystemList: MygolfServer + '/rest/handicap/handicap-systems',
  getPlayerHcpIdx: MygolfServer + '/rest/handicap/player-handicap-index', //{playerId}?handicapSystem=id
  syncHandicapIndex: MygolfServer + '/rest/handicap/sync-handicap-index', //{playerId}?handicapSystem*=id&playerId*
  getLatestCourseHandicap: MygolfServer + '/rest/handicap/course-handicap/player', //{playerId**}/{teeBoxName}**?firstNine**&secondNine=
  approveClubMembership: '/approve', //{playerId}
  suspendClubMembership: '/suspend', //{playerId}
  addCaddyUnavailability: MygolfServer + '/rest/club/caddy/unavailability', // {caddieId*} /create?caddieId*,fromDate*,toDate*
  listCaddyUnavailability: MygolfServer + '/rest/club/caddy/unavailability', //{caddieId*} ?caddieId*,fromDate,toDate
  removeCaddyUnavailability: MygolfServer + '/rest/club/caddy/unavailability', //{unavailabilityId*}/delete
  displayCaddySchedule: MygolfServer + '/rest/club/caddy/club-schedule', //path {clubId*}?forDate
  getBuggyTypes: MygolfServer + '/rest/club/:clubId/buggy-types',

  /** LEAGUE APIs
   *
   */

  getLeagueCompetition: MygolfServer + '/rest/league/competition', //{compId*},
  leagueEclectic: '/eclectic', //path
  leagueScorecards: '/scorecards', //path
  leagueLeaderboard: '/leaderboard', //path
  getLeagueSeason: '/get-season', //path
  getLeague: MygolfServer + '/rest/league', //{seasonId*}
  leagueRounds: '/rounds', //path
  leagueLowestGrossLeaderboard: '/lowest-gross-leaderboard', //path

  getPlayerMaxBookingCount: MygolfServer + '/rest/tee-time/booking', // path {clubId*}/{playerId*}/booking-count
  addBuggyUnavailability: MygolfServer + '/rest/club/buggy/unavailability', // {buggyId*} /create?buggyId*,fromDate*,toDate*
  listBuggyUnavailability: MygolfServer + '/rest/club/buggy/unavailability', //{buggyId*} ?buggyId*,fromDate,toDate
  removeBuggyUnavailability: MygolfServer + '/rest/club/buggy/unavailability', //{unavailabilityId*}/delete
  getPaymentMethodList: MygolfServer + '/rest/payment/payment-methods',
  updateClubPaymentMethod: MygolfServer + '/rest/payment/bills/:billId/payment-method',
  getBillDetails: MygolfServer + '/rest/payment/bills/:billId',
  setBookingCancelGuard: '/set-cancel-guard', //{bookingId} ?cancelGuard=false

  searchBookingClub: teeTimeBookingBase + '/search-for-club', //{clubId}?statusType
  /**
   * @param clubId - required
   * @param courseId - integer
   * @param fromDate - string
   * @param toDate - string
   * @param statusType | A - Active, I - Inactive, B - Both, C - Custom For custom specify comma separated list of status in statusList
   * Default value : B
   * @param statusList
   * @param search
   * @param pageSize def 20
   * @param pageNo def 1
   */
  searchBookingPlayer: teeTimeBookingBase + '/search-for-player', //{playerId}
  /**
   * @param playerId - required
   * @param clubId
   * @param courseId - integer
   * @param fromDate - string
   * @param toDate - string
   * @param statusType | A - Active, I - Inactive, B - Both, C - Custom For custom specify comma separated list of status in statusList
   * Default value : B
   * @param statusList
   * @param search
   * @param pageSize def 20
   * @param pageNo def 1
   * @param descendingDate (default false)
   */
  searchBookingAgent: teeTimeBookingBase + '/search-for-agent', //{clubId}?statusType
  /**
   * @param partnerId - required
   * @param courseId - integer
   * @param fromDate - string
   * @param toDate - string
   * @param statusType | A - Active, I - Inactive, B - Both, C - Custom For custom specify comma separated list of status in statusList
   * Default value : B
   * @param statusList
   * @param search
   * @param pageSize def 20
   * @param pageNo def 1
   */
  refundRedeemForClub: MygolfServer + '/rest/club/refund-redeem', //{clubId}
  refundRedeemForPlayer: MygolfServer + '/rest/player/refund-redeem', //{clubId}
  /**
   * @param playerId* - required
   * @param startDate* - required
   * @param endDate
   * @param include - possible values 'refund', 'redeem' and 'both', default is 'both'
   */
  undoRefundBooking: teeTimeBookingBase + '/undo-refund', //?bookingId*&refundInstanceId*
  undoCancelBooking: teeTimeBookingBase + '/undo-cancel', //?bookingId*
  updateNinesBooking: teeTimeBookingBase + '/change-nines', //?bookingId*&ninesPlayed* (1|2)
  downloadBookingBill: teeTimeBookingBase + '/:bookingId/download-booking-bill',
  generateBookingBill: teeTimeBookingBase + '/:bookingId/generate-booking-bill',
  generateItemizedBill: teeTimeBookingBase + '/:bookingId/generate-itemized-bill',
  genMultiItemizedBill: MygolfServer + '/rest/tee-time/clubs/:clubId/generate-itemized-bills',
  genAgentMultiItemizedBill: MygolfServer + '/rest/tee-time/clubs/:clubId/booking-agents/:bookingAgent/generate-itemized-bills',
  getSummaryDailyReportCashier: MygolfServer + '/rest/tee-time/reports' + '/cashier-daily-summary/generate',
  downloadSummaryDailyReportCashier: MygolfServer + '/rest/tee-time/reports' + '/cashier-daily-summary/download',
  getSummaryDailyReport: MygolfServer + '/rest/tee-time/reports/clubs/:clubId/daily-report/generate',

  clubMemberships: {
    listForPlayer: MygolfServer + '/rest/players/:playerId/club-memberships',
    listForPlayerClub: MygolfServer + '/rest/players/:playerId/club-memberships/:clubId',
    createUpdatePrimary: MygolfServer + '/rest/club/:clubId/memberships',
    /**
     * @param clubId required
     * @param playerId required
     * @param membershipNo - request body and required
     * @param membershipType- request body and required
     * @param joinedOn - request body and required string for date ('YYYY-MM-DD')
     */
    deleteMembership: MygolfServer + '/rest/club/:clubId/memberships/:membershipId',
    listClubMembershipTypes: MygolfServer + '/rest/club/:clubId/membership-types',
    clubOptions: MygolfServer + '/rest/club/:clubId/membership-options',
    getSpecificClubMembership: MygolfServer + '/rest/club/:clubId/memberships/:membershipId',
    listClubMemberships: MygolfServer + '/rest/club/:clubId/memberships',
    suspendSingle: MygolfServer + '/rest/club/:clubId/memberships/:membershipId/suspend-membership',
    suspendMulti: MygolfServer + '/rest/club/:clubId/memberships/suspend-membership',
    updateStatus: MygolfServer + '/rest/club/:clubId/memberships/:membershipId/update-status',
  },

  playerAccounts: {
    listInClub: MygolfServer + '/rest/accounts/clubs/:clubId',
    getClubAccount: MygolfServer + '/rest/accounts/clubs/:clubId/players/:playerId',
    listStatements: MygolfServer + '/rest/accounts/statements',
    getStatementById: MygolfServer + '/rest/accounts/statements/:statementId',
    listTransations: MygolfServer + '/rest/accounts/transactions',
    getTransactionByStatement: MygolfServer + '/rest/accounts/transactions/:statementId',
    updateCreditLimit: MygolfServer + '/rest/accounts/clubs/:clubId/players/:playerId/credit-limit', //[PUT]
    getMaxChargeableClub: MygolfServer + '/rest/accounts/clubs/:clubId/players/:playerId/max-chargeable-amount', //[GET]
    bookingChargeToClub: MygolfServer + '/rest/tee-time/booking/charge-to-club', //?bookingId*&&playerId*&&amount*
    paymentToClub: MygolfServer + '/rest/accounts/clubs/:clubId/players/:playerId/payment',
    importClubPayments: MygolfServer + '/rest/accounts/clubs/:clubId/payment/import',
    importClubTransactions: MygolfServer + '/rest/accounts/clubs/:clubId/transactions/import',
    getImportTransactionTemplate: MygolfServer + '/rest/accounts/clubs/:clubId/transactions/import-template',
    getClubPaymentTransactions: MygolfServer + '/rest/accounts/payments',
    getStats: MygolfServer + '/rest/accounts/clubs/:clubId/players/:playerId/stat', //lastNMonths
    // player make own payment to club
    makePayment: MygolfServer + '/rest/accounts/clubs/:clubId/players/:playerId/payment',
    undoTransaction: MygolfServer + '/rest/accounts/clubs/:clubId/players/:playerId/undo-transaction/:transactionId',
  },
  teeTime: {
    updateSlotParameters: MygolfServer + '/rest/tee-time/slot/update-slot-parameters',
    updateSlotBuggyCaddieSettings: teeTimeSlotBase + '/buggy-caddie-settings',
    /**
     * @param slotDayId *
     * @param slotNo *
     * @param buggyRequired - Y,N, null or any other value will ignore
     * @param maxPlayersPerBuggy - null value will ignore
     * @param caddieRequired  - Y,N, null or any other value will ignore
     * @param maxPlayersPerCaddie - null value will ignore
     */
    getSlotPrices: teeTimeSlotBase + '/prices', //list prices for components for a given slot
    /**
     * @param slotDayId *
     * @param slotNo *
     * @param components - array<string>
     * @param playerTypes - array<string>
     * @param jumboFlight - boolean
     */
    addUpdateAdditionalItems: teeTimeBookingBase + '/:bookingId/additional-items',
    /**
     * @param bookingId * integer
     * @param componentId string
     * @param itemCount integer
     * @param unitPrice - if this is passed, this will override the price from pricing plan
     * @param remarks - string
     */
    deleteAdditionalItems: teeTimeBookingBase + '/:bookingId/additional-items',
    /**
     * @param bookingId * integer
     * @param itemIds * array<integer>
     */
    getPricingComponents: MygolfServer + '/rest/tee-time/clubs/:clubId/pricing-components',
    /**
     * @param clubId * integer
     * @param activeOnly boolea - default: false
     * @param additionalOnly boolean - default: false
     */
    listPricingPlans: MygolfServer + '/rest/tee-time/pricing-plans/:clubId',
    searchSlots: teeTimeSlotBase + '/:clubId/tee-slots/search',
    searchAndUpdateSlots: teeTimeSlotBase + '/:clubId/tee-slots/search-and-updates',
    checkBookingExistsByReference: MygolfServer + '/rest/tee-time/booking/exists/by-reference',
    getBookingByReference: MygolfServer + '/rest/tee-time/booking/get/by-reference',
    updateBookingConfirmationStatus: MygolfServer + '/rest/tee-time/club/booking/update-booking-confirmation-status',
    searchForPartner: teeTimeBookingBase + '/search-for-agreement-partner/:partnerId', //{clubId}?statusType
    setLockerNumber: MygolfServer + '/rest/tee-time/booking/set-locker-numbers',
    downloadFlightLabel: MygolfServer + '/rest/tee-time/clubs/:clubId/download-booking-flight-labels',
    generateFlightLabel: MygolfServer + '/rest/tee-time/clubs/:clubId/generate-booking-flight-labels',
  },
  checkUsernameAvailability: MygolfServer + userProfile + '/user-name-available', //?userName=
  profileUsers: userProfile + '/users',
  listUsers: userProfile + '/list',
  createUpdateUserName: '/create-user-name', //<userId>?userName=
  userProfiles: {
    updateDefaultAddress: '/update-default-address', //addressName=
    saveAddress: '/save-address', //addressName=*&setDefault=<false|true>
    setDefaultAddress: '/set-default-address', //?addressName=
    deleteAddress: '/delete-address', //?addressName
    getUserDetails: '/users/:userId',
    getList: MygolfServer + '/rest/user-profile/list',
  },
  playerClubWallet: {
    addClubTopup: MygolfServer + '/rest/wallets/clubs/:clubId/players/:playerId',
    getWalletTransactions: MygolfServer + '/rest/wallets/clubs/:clubId/wallet-transactions',
    getWalletTopups: MygolfServer + '/rest/wallets/clubs/:clubId/wallet-top-ups',
    getClubWalletBalance: MygolfServer + '/rest/wallets/clubs/:clubId/balances',
    deleteClubTopup: MygolfServer + '/rest/wallets/clubs/:clubId/players/:playerId/topups/:topUpId',
    deductWalletBalance: MygolfServer + '/rest/wallets/clubs/:clubId/players/:playerId/deduct', //! can use for expenditure
    // deleteTransaction: MygolfServer + "/rest/wallets/clubs/:clubId/players/:playerId/transactions/:transactionId", //! not used anymore
    getWalletBalance: MygolfServer + '/rest/wallets/clubs/:clubId/balances/:playerId',
    refundWalletBalance: MygolfServer + '/rest/tee-time/booking/revert-wallet-balance',
    updateTopupAttribute: MygolfServer + '/rest/wallets/clubs/:clubId/players/:playerId/topups/:topUpId',
    getExpenditureTypes: MygolfServer + '/rest/wallets/clubs/:clubId/expenditure-types',
    revertWalletBalance: MygolfServer + '/rest/wallets/revert-wallet-balance',
  },

  newAuthentication: MygolfServer + '/rest/authenticate',
  changePasswordByAdmin: MygolfServer + '/rest/changepassword-by-admin',

  lite: {
    getClubMembershipOpen: MygolfServer + '/rest/player/clubmemberships/open',
    searchPlayersOpen: MygolfServer + '/rest/players/search/open',
    clubListOpen: MygolfServer + '/rest/clubs/search/open',
    getClubInfo: MygolfServer + '/rest/club/:clubId/open',
  },
  outlet: {
    getList: MygolfServer + '/rest/outlets', //? only used by super admin,
    getInfo: MygolfServer + '/rest/outlets/:outletId',
    update: MygolfServer + '/rest/outlets/:outletId',
    remove: MygolfServer + '/rest/outlets/:outletId',
    getOutletTypes: MygolfServer + '/rest/outlets/outlet-types',
    getClubOutletList: MygolfServer + '/rest/outlets/clubs/:clubId',
    getClubOutletTypes: MygolfServer + '/rest/outlets/clubs/:clubId/outlet-types',
    getAvailableTypes: MygolfServer + '/rest/outlets/available-outlet-types',
    clubOutletTypes: {
      getDefinedList: MygolfServer + '/rest/outlets/clubs/:clubId/club-outlet-types',
      setDefinedList: MygolfServer + '/rest/outlets/clubs/:clubId/club-outlet-types', //[POST]
      getUser: MygolfServer + '/rest/outlets/clubs/:clubId/users/:userId/outlet-types',
      setUser: MygolfServer + '/rest/outlets/clubs/:clubId/users/:userId/outlet-types', //[POST]
      addUsers: MygolfServer + '/rest/outlets/clubs/:clubId/outlet-type-users', //[POST]
      deleteUsers: MygolfServer + '/rest/outlets/clubs/:clubId/outlet-type-users', //[DELETE]
    },
    getLoggedInOutletList: MygolfServer + '/rest/outlets/clubs/:clubId/my-outlets', //? List the outlets for a logged in club user. User must be added to the outlet
    createClubOutlet: MygolfServer + '/rest/outlets/clubs/:clubId',
    workingHours: MygolfServer + '/rest/facilities/:outletId/working-hours',
    clearTimings: MygolfServer + '/rest/facilities/:outletId/clear-timings',
    closingTimes: MygolfServer + '/rest/facilities/:outletId/closing-times',
    addClosures: MygolfServer + '/rest/facilities/:outletId/closures',
    updateClosures: MygolfServer + '/rest/facilities/closures/:closureId',
    deleteClosures: MygolfServer + '/rest/facilities/closures/:closureId',
    getClosures: MygolfServer + '/rest/facilities/closures',
    defaultPricing: MygolfServer + '/rest/facilities/:facilityId/default-pricing',
    getDetails: MygolfServer + '/rest/outlets/:outletId',
    updateBookingRules: MygolfServer + '/rest/outlets/:outletId/booking-rules',
    addUser: MygolfServer + '/rest/outlets/:outletId/:userId',
    removeUser: MygolfServer + '/rest/outlets/:outletId/:userId',
    items: {
      add: MygolfServer + '/rest/outlets/:outletId/items',
      update: MygolfServer + '/rest/outlets/:outletId/items/:itemId',
      bulkUpdate: MygolfServer + '/rest/outlets/:outletId/items/update',
      delete: MygolfServer + '/rest/outlets/:outletId/items/:itemId',
      clearTimings: MygolfServer + '/rest/facilities/:outletId/items/:itemId/clear-timings',
      closingTimes: MygolfServer + '/rest/facilities/:outletId/items/:itemId/closing-times',
      closures: MygolfServer + '/rest/facilities/:outletId/items/:itemId/closures',
      addClosures: MygolfServer + '/rest/facilities/:outletId/items/:itemId/closures',
      deleteClosures: MygolfServer + '/rest/facilities/:outletId/items/:itemId/closures',
      addPricing: MygolfServer + '/rest/facilities/:facilityId/items/:itemId/pricing',
      workingHours: MygolfServer + '/rest/facilities/:outletId/items/:itemId/working-hours',
      setPricing: MygolfServer + '/rest/facilities/:facilityId/items/:itemId/pricing',
      itemsDelete: MygolfServer + '/rest/outlets/:outletId/items/delete',
    },
    locations: {
      add: MygolfServer + '/rest/outlets/:outletId/locations',
      update: MygolfServer + '/rest/outlets/:outletId/locations/:locationId',
      delete: MygolfServer + '/rest/outlets/:outletId/locations/:locationId',
      clearTimings: MygolfServer + '/rest/facilities/:outletId/locations/:locationId/clear-timings',
      closingTimes: MygolfServer + '/rest/facilities/:outletId/locations/:locationId/closing-times',
      closures: MygolfServer + '/rest/facilities/:outletId/locations/:locationId/closures',
      addClosures: MygolfServer + '/rest/facilities/:outletId/locations/:locationId/closures',
      deleteClosures: MygolfServer + '/rest/facilities/:outletId/locations/:locationId/closures',
      addPricing: MygolfServer + '/rest/facilities/:facilityId/locations/:locationId/pricing',
      workingHours: MygolfServer + '/rest/facilities/:outletId/locations/:locationId/working-hours',
      setPricing: MygolfServer + '/rest/facilities/:facilityId/locations/:locationId/pricing',
    },
    pricing: {
      add: MygolfServer + '/rest/facilities/:facilityId/pricing',
      getList: MygolfServer + '/rest/facilities/pricing',
      update: MygolfServer + '/rest/facilities/pricing/:pricingId',
      delete: MygolfServer + '/rest/facilities/pricing/:pricingId',
      getBasePrices: MygolfServer + '/rest/facilities/pricing/:pricingId/base-prices',
      addBasePrices: MygolfServer + '/rest/facilities/pricing/:pricingId/base-prices',
      updateBasePrices: MygolfServer + '/rest/facilities/pricing/:pricingId/base-prices/:basePriceId',
      deleteBasePrices: MygolfServer + '/rest/facilities/pricing/:pricingId/base-prices/:basePriceId',
      addTimeRangePrice: MygolfServer + '/rest/facilities/pricing/:pricingId/time-range-price',
      deleteTimeRangePrice: MygolfServer + '/rest/facilities/pricing/:pricingId/time-range-price',
      addBaseTimeRangePrice: MygolfServer + '/rest/facilities/pricing/:pricingId/base-prices/:basePriceId/time-range-price',
      deleteBaseTimeRangePrice: MygolfServer + '/rest/facilities/pricing/:pricingId/base-prices/:basePriceId/time-range-price',
      addBasePlayerTypePrices: MygolfServer + '/rest/facilities/pricing/:pricingId/base-prices/:basePriceId/player-type-prices/:playerType',
      deleteBasePlayerTypePrices:
        MygolfServer + '/rest/facilities/pricing/:pricingId/base-prices/:basePriceId/player-type-prices/:playerType',
    },
    addImages: MygolfServer + '/rest/outlets/:outletId/images',
    removeImages: MygolfServer + '/rest/outlets/:outletId/images', //[delete]
    rearrangeImages: MygolfServer + '/rest/outlets/:outletId/images', //[put]
    searchFacilities: MygolfServer + '/rest/facilities/clubs/:clubId/search-facilities',
    bookings: {
      search: MygolfServer + '/rest/facilities/bookings/search',
      getForCart: MygolfServer + '/rest/facilities/bookings/for-cart',
      bookSlot: MygolfServer + '/rest/facilities/bookings/book',
      createOrder: MygolfServer + '/rest/facilities/bookings/create-order',
      cancel: MygolfServer + '/rest/facilities/bookings/:bookingId/cancel',
      reprice: MygolfServer + '/rest/facilities/bookings/:bookingId/reprice',
      updateAdditionalCount: MygolfServer + '/rest/facilities/bookings/:bookingId/update-additional-count',
      updatePax: MygolfServer + '/rest/facilities/bookings/:bookingId/update-pax',
      removeOrder: MygolfServer + '/rest/facilities/bookings/orders/:orderId',
      getOrders: MygolfServer + '/rest/orders',
    },

    // facility: {
    //     get
    // }
    facilitiesOverrideBasePrice: MygolfServer + '/rest/facilities/pricing/:pricingId/override',
    facilitiesRearangeImage: MygolfServer + '/rest/outlets/:outletId/images',
  },
  userAccount: {
    processDeleteRequests: MygolfServer + '/rest/players/process-delete-requestes', //[POST]
    requestAccountDeletion: MygolfServer + '/rest/players/request-account-deletion', //[PUT]
    listAccountDeletionRequests: MygolfServer + '/rest/players/requesting-account-deletion',
    undoDeleteRequest: MygolfServer + '/rest/players/undo-delete-request',
  },

  playerInsurance: {
    listInsurances: MygolfServer + '/rest/players/:playerId/insurances',
    addInsurance: MygolfServer + '/rest/players/:playerId/insurances',
    updateDeleteInsurance: MygolfServer + '/rest/players/:playerId/insurances/:insuranceId', // [POST] [DELETE]
    listAll: MygolfServer + '/rest/players/player-insurances',
  },

  partnerDiscountCompany: {
    list: MygolfServer + '/rest/partners',
    getDetails: MygolfServer + '/rest/partners/:partnerId',
    createApplication: MygolfServer + '/rest/partners/:partnerId/programs/:programId/create-application',
    listApplications: MygolfServer + '/rest/partners/program-membership-applications',
    listPrograms: MygolfServer + '/rest/partners/:partnerId/programs',
    listAllMembers: MygolfServer + '/rest/partners/:partnerId/members',
    listProgramMembers: MygolfServer + '/rest/partners/:partnerId/programs/:programId/members',
    updateApplication: MygolfServer + '/rest/partners/:partnerId/programs/:programId/update-application', //PUT
    updateMembership: MygolfServer + '/rest/partners/:partnerId/members/:playerMembershipId/update',
    updateNumbers: MygolfServer + '/rest/partners/:partnerId/programs/:programId/applications/:applicationId/update-numbers',
    approveMembership: MygolfServer + '/rest/partners/:partnerId/members/:playerMembershipId/verification',
    approveApplications: MygolfServer + '/rest/partners/:partnerId/approve-applications',
    getAgentClubSettings: MygolfServer + '/rest/partners/:partnerId/booking-agent-settings/:clubId',
    getProgramBookings: MygolfServer + '/rest/partners/:partnerId/programs/:programId/bookings',
    getPartnerBookings: MygolfServer + '/rest/partners/:partnerId/bookings',
  },
  deriveHandicap: MygolfServer + '/rest/handicap/derive-player-handicap',
  getBookingReportList: MygolfServer + '/rest/tee-time/reports/list',
  external: {
    finance: {
      financio: {
        initiateClub: MygolfServer + '/external/financio/clubs/:clubId/register',
      },
      xero: {
        initiateClub: MygolfServer + '/external/xero/clubs/:clubId/register',
      },
    },
    system: {
      getList: MygolfServer + '/external/systems',
      getInterfaces: MygolfServer + '/external/interfaces',
      getAccounts: MygolfServer + '/external/interfaces/clubs/:clubId/systems/:systemId/accounts',
    },
  },
  clubPayments: {
    getClubInstances: MygolfServer + '/rest/club-payments/clubs/:clubId/instances',
    getImports: MygolfServer + '/rest/accounts/payment-imports',
  },
  finance: {
    listTransactions: MygolfServer + '/rest/transactions',
    generateTransactions: MygolfServer + '/rest/transactions/:clubId/generate-transactions',
    syncTransactions: MygolfServer + '/rest/transactions/:clubId/sync-transactions',
    listTrxnGroups: MygolfServer + '/rest/transactions/transaction-groups',
    listTrxnTypes: MygolfServer + '/rest/transactions/transaction-types',
    clubTrxnTypes: {
      getList: MygolfServer + '/rest/transactions/transaction-types/:clubId',
      addType: MygolfServer + '/rest/transactions/transaction-types/:clubId',
      deleteTrxn: MygolfServer + '/rest/transactions/transaction-types/:clubId/:transactionTypeId',
      listExportMappings: MygolfServer + '/rest/transactions/transaction-types/:clubId/export-mappings',
      updateExportMappings: MygolfServer + '/rest/transactions/transaction-types/:clubId/export-mappings/:transactionTypeId',
      updateDeleteExportMappings: MygolfServer + '/rest/transactions/transaction-types/:clubId/export-mappings/:transactionTypeId',
      listPaymentMappings: MygolfServer + '/rest/transactions/transaction-types/:clubId/payment-mappings',
      updatePaymentMappings: MygolfServer + '/rest/transactions/transaction-types/:clubId/payment-mappings',
      deletePaymentMappings: MygolfServer + '/rest/transactions/transaction-types/:clubId/payment-mappings/:mappingId',
      listPricingMappings: MygolfServer + '/rest/transactions/transaction-types/:clubId/pricing-component-mappings',
      updatePricingMappings: MygolfServer + '/rest/transactions/transaction-types/:clubId/pricing-component-mappings/:pricingComp',
      deletePricingMappings: MygolfServer + '/rest/transactions/transaction-types/:clubId/pricing-component-mappings/:pricingComp',
      listRefundMappings: MygolfServer + '/rest/transactions/transaction-types/:clubId/refund-mappings',
      updateRefundMappings: MygolfServer + '/rest/transactions/transaction-types/:clubId/refund-mappings',
      deleteRefundMappings: MygolfServer + '/rest/transactions/transaction-types/:clubId/refund-mappings/:mappingId',
      listPOSMappings: MygolfServer + '/rest/pos-sales/clubs/:clubId/transaction-type-mappings',
      updatePOSMappings: MygolfServer + '/rest/pos-sales/clubs/:clubId/transaction-type-mappings',
      deletePOSMappings: MygolfServer + '/rest/pos-sales/clubs/:clubId/transaction-type-mappings/:mappingId',
    },
    exports: {
      listInstances: MygolfServer + '/rest/transactions/exports',
      getInstanceDetails: MygolfServer + '/rest/transactions/exports/:instanceId',
      getInstanceTrxnsList: MygolfServer + '/rest/transactions/exports/:instanceId/transactions',
      generate: MygolfServer + '/rest/transactions/generate-exports',
    },
  },
  productsPricing: {
    listClubComponents: MygolfServer + '/rest/club/:clubId/pricing-components',
    addUpdateClubComponents: MygolfServer + '/rest/club/:clubId/pricing-components',
    getClubCompDetails: MygolfServer + '/rest/club/:clubId/pricing-components/:componentId',
    deleteClubComponent: MygolfServer + '/rest/club/:clubId/pricing-components/:componentId',
  },
  taxProfiles: {
    getList: MygolfServer + '/rest/club/tax-profiles',
    toggleActive: MygolfServer + '/rest/club/:clubId/tax-profiles/:profileId',
    addUpdate: MygolfServer + '/rest/club/:clubId/tax-profiles',
    delete: MygolfServer + '/rest/club/:clubId/tax-profiles/:profileId',
  },
  clubOrder: {
    getOrdersList: MygolfServer + '/rest/club/:clubId/orders',
    addNewOrder: MygolfServer + '/rest/club/:clubId/orders',
    getOrderDetails: MygolfServer + '/rest/club/:clubId/orders/:orderId',
    updateOrderDetails: MygolfServer + '/rest/club/:clubId/orders/:orderId',
    deleteOrder: MygolfServer + '/rest/club/:clubId/orders/:orderId',
    cancelOrder: MygolfServer + '/rest/club/:clubId/orders/:orderId/cancel', //put
    confirmOrder: MygolfServer + '/rest/club/:clubId/orders/:orderId/confirm', //put
    finalizeOrder: MygolfServer + '/rest/club/:clubId/orders/:orderId/finalize', //put
    items: {
      add: MygolfServer + '/rest/club/:clubId/orders/:orderId/order-items',
      update: MygolfServer + '/rest/club/:clubId/orders/:orderId/order-items/:itemId',
      delete: MygolfServer + '/rest/club/:clubId/orders/:orderId/order-items/:itemId',
    },
    addPayment: MygolfServer + '/rest/club/:clubId/orders/:orderId/payments',
    updatePayment: MygolfServer + '/rest/club/:clubId/orders/:orderId/payments/:paymentId',
    deletePayment: MygolfServer + '/rest/club/:clubId/orders/:orderId/payments/:paymentId',
    verifyPayment: MygolfServer + '/rest/club/:clubId/orders/:orderId/payments/:paymentId',
    listClubCustomers: MygolfServer + '/rest/club/:clubId/customers',
    addClubCustomer: MygolfServer + '/rest/club/:clubId/customers/add',
    updateClubCustomer: MygolfServer + '/rest/club/:clubId/customers/update',
    deleteClubCustomer: MygolfServer + '/rest/club/:clubId/customers/:customerCode',
    doRefundOrder: MygolfServer + '/rest/club/:clubId/orders/:orderId/do-refund',
    undoRefundOrder: MygolfServer + '/rest/club/:clubId/orders/:orderId/undo-refund/:refundId',
    chargeToAccount: MygolfServer + '/rest/club/:clubId/orders/:orderId/charge-to-account',
    reprice: MygolfServer + '/rest/facilities/bookings/reprice/orders/:orderId',
    generateReport: MygolfServer + '/rest/club/:clubId/orders/:orderId/generate-order-print',
    downloadReport: MygolfServer + '/rest/club/:clubId/orders/:orderId/download-order-print',
    productPackages: {
      list: MygolfServer + '/rest/club/:clubId/product-packages',
      add: MygolfServer + '/rest/club/:clubId/product-packages',
      update: MygolfServer + '/rest/club/:clubId/product-packages/:packageId',
      getDetail: MygolfServer + '/rest/club/:clubId/product-packages/:packageId',
      delete: MygolfServer + '/rest/club/:clubId/product-packages/:packageId',
      addItem: MygolfServer + '/rest/club/:clubId/product-packages/:packageId/package-items',
      deleteItem: MygolfServer + '/rest/club/:clubId/product-packages/:packageId/package-items',
      addToOrder: MygolfServer + '/rest/club/:clubId/orders/:orderId/product-packages/:packageId',
    },
  },

  order: {
    search: MygolfServer + '/rest/orders',
    searchFacilityOrders: MygolfServer + '/rest/facilities/bookings/facility-orders',
    facilityBookingById: MygolfServer + '/rest/facilities/bookings/:Id',
  },
  promo: {
    getContexts: MygolfServer + '/rest/promo/contexts',
    getAllCoupons: MygolfServer + '/rest/promo/coupons', //context&clubId&partnerId&activeOnly&validFrom&validUntil&search&pageSize&pageNo
    getActiveCoupons: MygolfServer + '/rest/promo/coupons/active', //context&couponCode&asOf
    isAnyActive: MygolfServer + '/rest/promo/coupons/is-active', //context
  },
  clubGroups: {
    list: MygolfServer + '/rest/club/club-groups',
    addUpdate: MygolfServer + '/rest/club/club-groups',
    getDetails: MygolfServer + '/rest/club/club-groups/:groupId',
    delete: MygolfServer + '/rest/club/club-groups/:groupId',
    getUsers: MygolfServer + '/rest/club/club-groups/:groupId/users',
    associateUsers: MygolfServer + '/rest/club/club-groups/:groupId/users',
    deassociateUsers: MygolfServer + '/rest/club/club-groups/:groupId/users/:userId',
    setOrRemoveClub: MygolfServer + '/rest/club/:clubId/club-groups', // pass groupId=null if need to remove club from the group
    createUser: MygolfServer + '/rest/register/club-group-user',
  },
  user: {
    setRoles: MygolfServer + '/rest/user/set-roles',
    availableRoles: MygolfServer + '/rest/user-profile/roles',
  },
  bookingAgent: {
    chargeToAccount: MygolfServer + '/rest/tee-time/booking/charge-agent-account',
    maxChargeableAmount: MygolfServer + '/rest/partners/booking-agents/:partnerId/clubs/:clubId/max-chargeable',
    clubSettings: MygolfServer + '/rest/partners/booking-agents/settings',
    updateClubSetting: MygolfServer + '/rest/partners/booking-agents/:partnerId/clubs/:clubId/settings',
    transactions: MygolfServer + '/rest/partners/booking-agents/transactions',
    offlinePaymentTopup: MygolfServer + '/rest/partners/booking-agents/:partnerId/clubs/:clubId/record-offline-payment',
    clearUpdateBookingBy: MygolfServer + '/rest/tee-time/club/booking/update-booking-agent',
    reportRevenueForClub: {
      download: MygolfServer + '/rest/partners/booking-agents/clubs/:clubId/download-revenue-report',
      generate: MygolfServer + '/rest/partners/booking-agents/clubs/:clubId/generate-revenue-report',
    },
    reportRevenueForAgent: {
      download: MygolfServer + '/rest/partners/booking-agents/:partnerId/download-revenue-report',
      generate: MygolfServer + '/rest/partners/booking-agents/:partnerId/generate-revenue-report',
    },
    clubPricingPlans: {
      getList: MygolfServer + '/rest/partners/booking-agents/:partnerId/clubs/:clubId/agent-pricing-plans',
      update: MygolfServer + '/rest/partners/booking-agents/:partnerId/clubs/:clubId/agent-pricing-plans',
      create: MygolfServer + '/rest/partners/booking-agents/:partnerId/clubs/:clubId/agent-pricing-plans',
      delete: MygolfServer + '/rest/partners/booking-agents/:partnerId/clubs/:clubId/agent-pricing-plans/:agentPricingPlanId',
      getEffective: MygolfServer + '/rest/partners/booking-agents/:partnerId/clubs/:clubId/effective-agent-pricing-plans',
    },
    updatePaymentRules: MygolfServer + '/rest/partners/booking-agents/:partnerId/clubs/:clubId/payment-rules',
    getBookingCount: MygolfServer + '/rest/tee-time/booking/:clubId/booking-agent/:bookingAgent/booking-count',
    statements: {
      list: MygolfServer + '/rest/partners/booking-agents/statements',
      generate: MygolfServer + '/rest/partners/booking-agents/clubs/:clubId/generate-statements',
      approve: MygolfServer + '/rest/partners/booking-agents/clubs/:clubId/approve-statements',
      cancel: MygolfServer + '/rest/partners/booking-agents/clubs/:clubId/cancel-statement',
      delete: MygolfServer + '/rest/partners/booking-agents/clubs/:clubId/delete-statement',
      getDetails: MygolfServer + '/rest/partners/booking-agents/statements/:statementId',
      downloadPrint: MygolfServer + '/rest/partners/booking-agents/statements/:statementId/download-statement-print',
      generatePrint: MygolfServer + '/rest/partners/booking-agents/statements/:statementId/generate-statement-print',
    },
    excludeBookingPlayer: MygolfServer + '/rest/tee-time/club/booking/agent-commission-exclusion', //PUT
    setCommissionComponent: MygolfServer + '/rest/partners/booking-agents/:partnerId/clubs/:clubId/commission-components', //PUT
  },
  teeTimeBooking: {
    club: {
      updateOfflinePayment: MygolfServer + '/rest/tee-time/club/booking/update-offline-payment',
    },
    test: {
      sendBookingFailed: MygolfServer + '/rest/tee-time/booking/failed',
      sendBookingSuccess: MygolfServer + '/rest/tee-time/booking/success',
    },
  },
  externalReport: {
    getList: MygolfServer + '/rest/reports',
    generatePDF: MygolfServer + '/rest/reports/:reportId/generate-pdf',
  },
  stayAndPlayPackage: {
    getPackages: packages, // Get List of packages
    requestPackage: packages + '/:packageId' + '/requests', // Used for package request
    estimatedCharge: packages + '/:packageId' + '/estimated-charge',
    deleteRequestedRoom: stayAndPlay + '/requests' + '/:requestId' + '/delete-room-requests',
    addRequestedRoom: stayAndPlay + '/requests' + '/:requestId' + '/add-room-requests',
    updateRoomRequests: stayAndPlay + '/requests' + '/:requestId' + '/update-room-requests',
    updateGameRequests: stayAndPlay + '/requests' + '/:requestId' + '/update-game-requests',
    updateRequest: stayAndPlay + '/requests' + '/:requestId' + '/update-request',
    deleteRequestedGame: stayAndPlay + '/requests' + '/:requestId' + '/delete-game-requests',
    addRequestedGame: stayAndPlay + '/requests' + '/:requestId' + '/add-game-requests',
  },
  stayAndPlay: {
    getBookedPackages: stayAndPlay + '/requests/my-requests', // Get player Request list
    getPackageRequests: stayAndPlay + '/requests', //For package Request
    requestPackageStayOptions: stayAndPlay + '/packages' + '/:packageId' + '/requests' + '/:requestId' + '/stay-options', // Used for Pakckage Stay options
    requestPackagePlayOptions: stayAndPlay + '/packages' + '/:packageId' + '/requests' + '/:requestId' + '/play-options', // Used for Pakckage Play options
    generateRequest: stayAndPlay + '/packages' + '/:packageId' + '/requests' + '/:requestId/generate-request', // To generate package booking request
    stayAndPlayRequest: stayAndPlay + '/packages' + '/:packageId' + '/requests' + '/:requestId',
    getRequestDetails: stayAndPlay + '/requests' + '/:requestId',
    addRequestAdjustments: stayAndPlay + '/requests/:requestId/adjustments',
    removeRequestAdjustment: stayAndPlay + '/requests/:requestId/adjustments/:sequence',
    updateRequestAdjustment: stayAndPlay + '/requests/:requestId/adjustments/:sequence',
    addOfflinePayment: stayAndPlay + '/requests/:requestId/capture-offline-payment',
    deleteOfflinePayment: stayAndPlay + '/requests/:requestId/delete-offline-payment',
    updateOfflinePayment: stayAndPlay + '/requests/:requestId/update-offline-payment',
    doRefund: stayAndPlay + '/requests/:requestId/do-refund',
    undoRefund: stayAndPlay + '/requests/:requestId/undo-refund',
    approveRequest: stayAndPlay + '/requests/:requestId/approve',
  },
  homeItems: {
    get: MygolfServer + '/rest/home-items',
    clubIcons: {
      get: MygolfServer + '/rest/home-items/clubs/:clubId/icons',
      save: MygolfServer + '/rest/home-items/clubs/:clubId/icons',
      delete: MygolfServer + '/rest/home-items/clubs/:clubId/icons',
    },
    partnerIcons: {
      get: MygolfServer + '/rest/home-items/partners/:partnerId/icons',
      save: MygolfServer + '/rest/home-items/partners/:partnerId/icons',
      delete: MygolfServer + '/rest/home-items/partners/:partnerId/icons',
    },
    setVisibility: MygolfServer + '/rest/home-items/set-visibility',
  },
  clubPOSandSales: {
    listPosSales: MygolfServer + '/rest/pos-sales', //! this is to list the sales
    listPOSCodes: MygolfServer + '/rest/point-of-sales', //! this is for POS Codes
    createClubPOSCode: MygolfServer + '/rest/point-of-sales/clubs/:clubId',
    getClubPOSCode: MygolfServer + '/rest/point-of-sales/clubs/:clubId/pos/:id', //! this is pos id or id?
    updateClubPOSCode: MygolfServer + '/rest/point-of-sales/clubs/:clubId/pos/:posId',
    deleteClubPOSCode: MygolfServer + '/rest/point-of-sales/clubs/:clubId/pos/:posId',
    listPaymentCodes: MygolfServer + '/rest/payment-codes',
    downloadImportTemplate: MygolfServer + '/rest/pos-sales/clubs/:clubId/import-template',
    uploadImportPOS: MygolfServer + '/rest/pos-sales/clubs/:clubId/import',
    listImportInstances: MygolfServer + '/rest/pos-sales/import-instances',
    getImportInstancesById: MygolfServer + '/rest/pos-sales/clubs/:clubId/import-instances/:instanceId',
    getImportInstanceDetails: MygolfServer + '/rest/pos-sales/clubs/:clubId/get-import-instance',
  },
  hotel: {
    createNewHotel: MygolfServer + '/rest/stay-and-play/hotels',
    updateHotel: MygolfServer + '/rest/stay-and-play/hotels/:Id',
    searchHotel: MygolfServer + '/rest/stay-and-play/hotels',
    deleteHotel: MygolfServer + '/rest/stay-and-play/hotels/:Id',
    getHotelById: MygolfServer + '/rest/stay-and-play/hotels/:Id',
    AddHotelImage: MygolfServer + '/rest/stay-and-play/hotels/:Id/images',
    deleteHotelImage: MygolfServer + '/rest/stay-and-play/hotels/:Id/images',
    createHotelRoomImage: MygolfServer + '/rest/stay-and-play/hotels/:Id/rooms/:roomId/images',
    deleteHotelRoomImage: MygolfServer + '/rest/stay-and-play/hotels/:Id/rooms/:roomId/images',
    deleteHotelRooms: MygolfServer + '/rest/stay-and-play/hotels/:Id/rooms/:roomId',
    createNewHotelRooms: MygolfServer + '/rest/stay-and-play/hotels/:Id/rooms',
    updateHotelRooms: MygolfServer + '/rest/stay-and-play/hotels/:Id/rooms/:roomId',
  },
  currencies: {
    getCurrencies: MygolfServer + '/rest/currencies',
  },
  eInvoicing: {
    saveForPlayer: MygolfServer + '/rest/players/:playerId/e-invoice-info', //Mandatory: playerId, eInvoicingOption(string<None|Individual|Company>), country(string)
    getEntityDetails: MygolfServer + '/rest/e-invoicing/e-invoicing-entities/countries/:countryId/tins/:tin',
    // MygolfServer + '/rest/e-invoicing/entities/get', //Mandatory: countryId, tin(string)
    getEntityList: MygolfServer + '/rest/e-invoicing/e-invoicing-entities', //Mandatory: countryId
    //  MygolfServer + '/rest/e-invoicing/entities/list', //Mandatory: countryId
    saveOrderSetup: MygolfServer + '/rest/e-invoicing/orders/:orderId/save-invoice-setup',
    saveTeeBookingSetup: MygolfServer + '/rest/e-invoicing/tee-bookings/:bookingId/save-invoice-setup',
    extractTeeBooking: MygolfServer + '/rest/e-invoicing/tee-bookings/:bookingId/extract',
    extraOrder: MygolfServer + '/rest/e-invoicing/orders/:orderId/extract',
    checkTINvalid: MygolfServer + '/rest/e-invoicing/countries/:countryId/tins/:tin/validate',
    searchTIN: MygolfServer + '/rest/e-invoicing/countries/:countryId/search-tin',
    searchEInvoices: MygolfServer + '/rest/e-invoicing/e-invoices',
    getEInvoiceDetails: MygolfServer + '/rest/e-invoicing/e-invoices/:eInvoiceId',
  },
  competitions: {
    getCourseRatings: MygolfServer + '/rest/competitions/:compId/course-ratings',
    leaderboard: MygolfServer + '/rest/competitions/:compId/leaderboard',
    getDetails: MygolfServer + '/rest/competitions/:compId',
    getScorecardsByPlayer: MygolfServer + '/rest/scorecards/competitions/:compId/players/:playerId',
    getScorecardsByRound: MygolfServer + '/rest/scorecards/competitions/:compId/rounds/:roundNo',
    registerPlayer: MygolfServer + '/rest/competitions/:compId/register',
    getSessions: MygolfServer + '/rest/competitions/sessions/:compId',
    getFlightList: MygolfServer + '/rest/competitions/:compId/rounds/:roundNo/flights',
    cancelWaitList: MygolfServer + '/rest/competitions/:compId/cancel-waitlist',
    getList: MygolfServer + '/rest/competitions',
    getListLite: MygolfServer + '/rest/competitions/lite',
    getListLiteSecured: MygolfServer + '/rest/competitions/lite-secured',
    getRegisteredPlayers: MygolfServer + '/rest/competitions/:compId/registered-players',
    getTeamLeaderboard: MygolfServer + '/rest/competitions/:compId/team-leaderboard',
    getPlayerViews: MygolfServer + '/rest/competitions/:compId/player-views',
  },

  multiCourseCompetitions: {
    getDetails: MygolfServer + '/rest/multi-course-competitions/organizers/:organizerId/:multiCourseCompId',
    getContentsList: MygolfServer + '/rest/multi-course-competitions/organizers/:organizerId/:multiCourseCompId/contents',
    getContentDetails: MygolfServer + '/rest/multi-course-competitions/organizers/:organizerId/:multiCourseCompId/contents/:contentId',
    getRegisteredPlayers: MygolfServer + '/rest/multi-course-competitions/organizers/:organizerId/:multiCourseCompId/registered-players',
    getRegisteredPlayerDetails:
      MygolfServer + '/rest/multi-course-competitions/organizers/:organizerId/:multiCourseCompId/registered-players/:playerId',
    getRegisteredGuests: MygolfServer + '/rest/multi-course-competitions/organizers/:organizerId/:multiCourseCompId/guests',
    getRegisteredGuestDetails: MygolfServer + '/rest/multi-course-competitions/organizers/:organizerId/:multiCourseCompId/guests/:playerId',
    search: MygolfServer + '/rest/multi-course-competitions/search',
    getList: MygolfServer + '/rest/multi-course-competitions/list',
    listAllTeamPlayers: MygolfServer + '/rest/multi-course-competitions/organizers/:organizerId/:multiCourseCompId/team-players',
    getRounds: MygolfServer + '/rest/multi-course-competitions/organizers/:organizerId/:multiCourseCompId/rounds',
    getParticipants: MygolfServer + '/rest/multi-course-competitions/organizers/:organizerId/:multiCourseCompId/participants',
    getPlayerFlightScheduleView:
      MygolfServer + '/rest/multi-course-competitions/organizers/:organizerId/:multiCourseCompId/players/:playerId/schedule-and-flight',
    getCompetitionFlightScheduleView:
      MygolfServer +
      '/rest/multi-course-competitions/organizers/:organizerId/:multiCourseCompId/competitions/:competitionId/schedule-and-flight',
  },
  firebaseNotifications: {
    registerToken: MygolfServer + '/rest/notifications/register-token',
    sendToUser: {
      single: MygolfServer + '/rest/notifications/users/send',
      multiple: MygolfServer + '/rest/notifications/users/send-multiple',
    },
    sendToPlayer: {
      single: MygolfServer + '/rest/notifications/players/send',
      multiple: MygolfServer + '/rest/notifications/players/send-multiple',
    },
  },
  tournamentsView: {
    byAll: MygolfServer + '/rest/tournaments',
    byCompleted: MygolfServer + '/rest/tournaments/completed',
    byElapsed: MygolfServer + '/rest/tournaments/elapsed',
    byOngoing: MygolfServer + '/rest/tournaments/ongoing',
    byUpcoming: MygolfServer + '/rest/tournaments/upcoming',
    byRegistered: MygolfServer + '/rest/tournaments/registered',
  },
};
